export const DrawerHelper = {
    listenerOnClose(callback) {
        const callBackWithRemoveListener = () => {
            window.removeEventListener('closeDrawer', callBackWithRemoveListener);
            callback();
        };
        window.addEventListener('closeDrawer', callBackWithRemoveListener);
    }
};
